<div class="sidebar-layout">
  <div class="sidebar-layout-header">
    <ebw-monorepo-sidebar-header [icon]="'work_outline'" [title]="'map.sidebar.checkInOut.title'" [isSvg]="false"
      [isOutline]="false">
      {{ 'map.sidebar.checkInOut.info_section' | translate }}
    </ebw-monorepo-sidebar-header>
  </div>
  <div *ngIf="filtersForm" class="list-wrapper">
    <form class="d-flex flex-column mt-3 w-95" [formGroup]="filtersForm">
      <div class="form-group row">
        <mat-form-field class="col mt-2" appearance="outline">
          <mat-label>{{ 'map.sidebar.checkInOut.type.title' | translate }}</mat-label>
          <mat-select formControlName="type">
            <mat-option selected [value]="typeEnum.ALL">{{ 'map.sidebar.checkInOut.type.all' | translate }}</mat-option>
            <mat-option [value]="typeEnum.AREA">{{ 'map.sidebar.checkInOut.type.area' | translate }}</mat-option>
            <mat-option [value]="typeEnum.POINT">{{ 'map.sidebar.checkInOut.type.point' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-group row">
        <div *ngIf="companiesList.length > 1; else autoSelectCompany" class="col mt-2">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>System</mat-label>
            <mat-select [(value)]="selectedCompany" (selectionChange)="onSelectCompany($event)">
              <mat-option selected>Seleziona</mat-option>
              <mat-option
              *ngFor="let company of companiesList; let i = index"
              [value]="company.id"
              >
                {{company.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <ng-template #autoSelectCompany>
          <div class="col mt-2">
            <mat-label class="me-2">{{'map.sidebar.checkin_analysis.company_name' | translate}}</mat-label>
            <mat-label><b>{{formCompany?.name}}</b></mat-label>
          </div>
        </ng-template>
      </div>
      <div class="form-group row">
        <mat-form-field class="col mt-2" appearance="outline">
          <mat-label>{{ 'map.sidebar.checkInOut.user.title' | translate }}</mat-label>
          <input type="text" matInput formControlName="user" [matAutocomplete]="userAutoComplete"/>
          <mat-autocomplete #userAutoComplete="matAutocomplete" [displayWith]="displayFnUserAutoComplete" (optionSelected)="onUserSelected($event)">
            <mat-option *ngFor="let user of userfilteredOptions$ | async" [value]="user">
              {{ user?.username }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="form-group row">
        <mat-form-field class="col mt-2" appearance="outline">
          <mat-label>{{ 'map.sidebar.checkInOut.state.title' | translate }}</mat-label>
          <mat-select formControlName="status">
            <mat-option selected [value]="-1">{{ 'map.sidebar.checkInOut.state.all' | translate }}</mat-option>
            <mat-option [value]="statusEnum.OPEN">{{ 'map.sidebar.checkInOut.state.open' | translate }}</mat-option>
            <mat-option [value]="statusEnum.CLOSED">{{ 'map.sidebar.checkInOut.state.closed' | translate
              }}</mat-option>
            <!-- <mat-option [value]="statusEnum.EXPIRED">{{'map.sidebar.checkInOut.state.expired' | translate}}</mat-option> -->
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-group row">
        <mat-form-field class="col mt-2" appearance="outline">
          <mat-label>{{ 'map.sidebar.checkInOut.date_range.title' | translate }}</mat-label>
          <mat-date-range-input [rangePicker]="picker" formGroupName="date_range">
            <input matStartDate placeholder="Inizio" formControlName="start" />
            <input matEndDate placeholder="Fine" formControlName="end" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>

      <div class="form-group my-3 segmento-ottico-filter">
        <mat-slide-toggle [(ngModel)]="customAreaSearchEnable" [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onCustomAreaSearchEnable()">
          <span class="visibility-text">{{ 'map.sidebar.checkInOut.custom_area_search' | translate }}</span>
        </mat-slide-toggle>
        <div class="d-flex gap-1 mt-2">
          <ng-container *ngIf="!customAreaSearchSet">
            <button style="line-height: 1rem;" mat-flat-button color="accent" [disabled]="!customAreaSearchEnable" (click)="openDrawingTool()"
              class="w-100">
              <span>{{ 'map.sidebar.checkInOut.set_area_search' | translate }}</span>
            </button>
            <button style="line-height: 1rem;" mat-flat-button color="accent" [disabled]="!customAreaSearchEnable" (click)="setFullArea()"
              class="w-100">
              <span>{{ 'map.sidebar.checkInOut.current_area_search' | translate }}</span>
            </button>
          </ng-container>
          <button mat-flat-button color="warn" class="w-100" *ngIf="customAreaSearchSet" (click)="clearArea()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <div class="segmento-ottico-filter" *ngIf="!customAreaSearchEnable">
        <p class="default-info">{{ 'map.sidebar.checkInOut.fw_link.title' | translate }}</p>
        <small>{{ 'map.sidebar.checkInOut.fw_link.subtitle' | translate }}</small>

        <div class="form-group row">
          <mat-form-field class="col mt-2" appearance="outline">
            <mat-label>{{ 'map.sidebar.checkInOut.fw_link.fw_link_id' | translate }}</mat-label>
            <input matInput formControlName="fw_link_id" [matAutocomplete]="inputAutoComplete" />
            <mat-autocomplete class="map-searchbar" #inputAutoComplete="matAutocomplete"
              (optionSelected)="onAutocompleteSelectionChanged($event)">
              <mat-option *ngFor="let option of autoCompletefilteredOptions" [value]="option"
                [disabled]="!option.desc">
                <span *ngIf="!option.desc" class="d-block center"
                  [matTooltip]="'map.search.more_description' | translate" matTooltipPosition="right"
                  matTooltipClass="info-button-tooltip">
                  {{ 'map.search.more' | translate }}
                </span>

                <span *ngIf="option.desc" class="d-block" [matTooltip]="option.desc" matTooltipPosition="right"
                  matTooltipClass="info-button-tooltip">{{ option.desc }}
                </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="form-group row">
          <mat-form-field class="col mt-2" appearance="outline">
            <mat-label>{{ 'map.sidebar.checkInOut.fw_link.fw_link_buffer' | translate }}</mat-label>
            <input matInput formControlName="search_buffer" type="number" />
            <mat-error *ngIf="filtersForm.get('search_buffer').invalid">{{
              'map.sidebar.checkInOut.fw_link.fw_link_buffer-error' | translate
              }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="segmento-ottico-filter">
        <p class="default-info">{{ 'map.sidebar.checkInOut.item_req.title' | translate }}</p>
        <small>{{ 'map.sidebar.checkInOut.item_req.subtitle' | translate }}</small>
        <div class="form-group row">
          <mat-form-field class="col mt-2" appearance="outline">
            <mat-label>{{ 'map.sidebar.checkInOut.item_req.label' | translate }}</mat-label>
            <input matInput formControlName="item_req" />
          </mat-form-field>
        </div>
      </div>
    </form>
    <div class="d-flex justify-content-end gap-3 me-3 mt-2">
      <button mat-flat-button color="secondary" (click)="reset()" [disabled]="filtersForm.invalid">
        {{ 'common.reset' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="search()" [disabled]="filtersForm.invalid">
        {{ 'common.search' | translate }}
      </button>
    </div>
  </div>
</div>
